export default "__VITE_ASSET__5LRIoeXn__"